exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar-item {\n  font-size: 15px;\n  color: #666;\n  cursor: pointer;\n  padding: 17px 10px 17px 45px;\n  border-top: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  z-index: 98;\n}\n.sidebar-item:hover {\n  background-color: #c5c5c5;\n  color: #333;\n  text-decoration: none;\n}\n.sidebar-item i {\n  padding: 10px;\n}\n.sidebar-item.active {\n  text-decoration: none;\n  color: #444;\n  text-shadow: 0.35px 0 0;\n}\n.sidebar-item.active::before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 5px;\n  background-color: #08b208;\n}\n.sidebar-item.active .sidebar-item-icon {\n  color: #008000;\n}\n.sidebar-item:focus {\n  color: #666;\n}\n.sidebar-item .sidebar-item-icon {\n  position: absolute;\n  left: 9px;\n  top: 9px;\n  color: #999;\n}\n.summer-sidebar .sidebar-item {\n  padding: 17px;\n}\n.summer-sidebar .sidebar-accordion-content .sidebar-item {\n  padding: 17px 17px 17px 34px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/shared/styles/SidebarItem.styl
// module id = 934
// module chunks = 0 1